module.exports = __webpack_public_path__ + "img/1.9 Bad Debt - Report.6e682f0c.jpg";